/* eslint-disable class-methods-use-this */
import axios from "axios";

import {API_IN_HOUSE_KEY, API_SHIPPING, COMMON_HEADER_CONFIG} from "../config";

class ShipperService {
  getAccessToken = () => localStorage.getItem("accessToken");

  userId = () => localStorage.getItem("userId");

  createShipperInHouse = (data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "post",
        url: `${API_SHIPPING}/shipper`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          "x-user-id": this.userId(),
          Authorization: `Basic YmlwYmlwOmJpcGJpcA==`,
          "Content-Type": "application/json",
          "api-key": API_IN_HOUSE_KEY
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  editShipperInHouse = (id, data) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "put",
        url: `${API_SHIPPING}/shipper/${id}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          "x-user-id": this.userId(),
          Authorization: `Basic YmlwYmlwOmJpcGJpcA==`,
          "Content-Type": "application/json",
          "api-key": API_IN_HOUSE_KEY
        },
        data
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  getOneShipperInHouse = (id, params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_SHIPPING}/shipper/${id}?store_id=${params}`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          "x-user-id": this.userId(),
          Authorization: `Basic YmlwYmlwOmJpcGJpcA==`,
          "Content-Type": "application/json",
          "api-key": API_IN_HOUSE_KEY
        }
      };

      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });

  listShipperInHouse = (params) =>
    new Promise((resolve, reject) => {
      const config = {
        method: "get",
        url: `${API_SHIPPING}/shipper`,
        headers: {
          ...COMMON_HEADER_CONFIG,
          "x-user-id": this.userId(),
          Authorization: `Basic YmlwYmlwOmJpcGJpcA==`,
          "Content-Type": "application/json",
          "api-key": API_IN_HOUSE_KEY
        },
        params
      };
      axios(config)
        .then((response) => {
          if (response.data && response.data.code === "success") {
            resolve(response.data.data);
          } else {
            reject(response.data.data.error);
          }
        })
        .catch((error) => {
          reject(error);
        });
    });
}

const shipperService = new ShipperService();

export default shipperService;
